var tableI18n = {
  actionButton: 'action menu',
  cancelButton: 'Cancel',
  clearAllFilters: 'Clear Filters',
  columnResizeTooltip: 'Width: %{columnWidth} px',
  columnOptions: 'Column Options',
  deselectAllItems: 'Deselect all',
  downButton: 'move selected column down',
  itemSelected: '%s item selected',
  itemsSelected: '%s items selected',
  noItems: 'No Items Found',
  resetToDefault: 'Reset to Default',
  saveButton: 'Save',
  selectAllItems: 'Select all %{totalNumberOfItems} items',
  selectAllPageItems: 'select all items in the current page',
  sortedAscending: 'ascending sorted',
  sortedDescending: 'descending sorted',
  upButton: 'move selected column up'
};
export default tableI18n;